<template>
    <div class="webpush-box">
        <div>
            <p style="text-align: center;">安卓包</p>
            <p>支持黑屏锁屏挂后台，不支持划掉APP</p>
            <p style="text-align: center;">主屏幕</p>
            <p>支持黑屏锁屏挂后台，支持划掉APP</p>
            <p>版本支持：</p>
            <p>安卓：Chrome 50+</p>
            <p>IOS：16.4+ Safari</p>
            <p>特点：<span style="color: #4CAF50;">无需下载，添加即用</span></p>
        </div>
        <div>
            <div class="sel">
                <div :class="type == 0 ? 'selx' : ''" @click="type = 0"><img src="image/icon.png" />安卓包</div>
                <div :class="type == 1 ? 'selx' : ''" @click="type = 1"><img src="image/Safari.png" />Safari 16+</div>
                <div :class="type == 2 ? 'selx' : ''" @click="type = 2"><img src="image/Safari.png" />Safari 18+</div>
                <div :class="type == 3 ? 'selx' : ''" @click="type = 3"><img src="image/Chrome.png" />Chrome</div>
            </div>
            <div v-show="type == 0">
                <div>一、打开设置，应用管理，找到掌柜助手</div>
                <img src="image/apk/1.png" style="max-width: 300px;" />
                <div>二、【通知管理】允许通知打开</div>
                <img src="image/apk/2.png" style="max-width: 300px;" />
                <div>三、【权限管理】权限通知打开</div>
                <img src="image/apk/3.png" style="max-width: 300px;" />
                <div>四、【耗电管理】允许后台运行打开</div>
                <img src="image/apk/4.png" style="max-width: 300px;" />
                <div>注意：不同机型文案有所差异</div>
            </div>
            <div v-show="type != 0">
                <p>步骤一：使用版本支持的浏览器，打开群主后台链接</p>
                <a target="_blank" rel="nofollow" href="https://room.iciam2015.com/room.html">线路一</a>
                <a target="_blank" rel="nofollow" href="https://room.sdfzjj.com/room.html"
                    style="margin-left: 20px;">线路二</a>
                <div>
                    <p v-show="type == 1">步骤二：点击【共享】打开工具栏</p>
                    <p v-show="type == 2">步骤二：点击【···】，点击【共享】打开工具栏</p>
                    <p v-show="type == 3">步骤二：点击【···】打开工具栏</p>
                </div>
                <div>
                    <img v-show="type == 1" src="image/Safari/1.jpg" style="max-width: 300px;" />
                    <img v-show="type == 2" src="image/Safari/1.png" style="max-width: 300px;" />
                </div>
                <p>步骤三：找到【添加到主屏幕】并完成添加</p>
                <div>
                    <img v-show="type == 1" src="image/Safari/2.jpg" style="max-width: 300px;" />
                    <img v-show="type == 2" src="image/Safari/2.png" style="max-width: 300px;" />
                </div>
                <p>步骤四：添加完成后，回到主屏幕使用该APP登录即可</p>
                <img src="image/icon.png" style="width: 50px;" />
            </div>
        </div>
        <div>
            <p style="font-size: 14px;color: #f36d6d;">提示一：该版本完成登录即为订阅消息，退出登录即为退订消息</p>
            <p style="font-size: 14px;color: #f36d6d;">提示二：主屏幕等同于使用浏览器打开，具备同等APP所有功能</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Webpush',
    data() {
        return {
            type: 0
        }
    },
    methods: {
    }
}
</script>

<style scoped>
.webpush-box>div {
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    background-color: #fff;
}

.sel {
    display: flex;
    flex-wrap: wrap;
}

.sel>div {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin: 5px;
    padding: 5px;
    border: 1px solid #9E9E9E;
    border-radius: 5px;
    cursor: pointer;
}

.sel img {
    width: 22px;
    height: 22px;
    margin-right: 5px;
}

.selx {
    background-color: #03A9F4;
    color: #fff;
}
</style>
